import React from 'react';
import style from '../Debug.module.scss';

class ErrorPanel extends React.Component {
  render() {
    return (
      <div className={style.panel}>
        <div className={style.header}>Errors</div>
        <div className={style.body}>
          <div className={style.formLabel}>This will throw an unhandled error.</div>
          <button
            onClick={() => {
              this.setState(() => {
                throw new Error('User initiated error from the debug panel');
              });
            }}
            type="button"
          >
            Throw an Error
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorPanel;
